import { Folder, MessageCircle, Terminal as TerminalIcon } from "lucide-react";
import { Logo } from "../Logo";

interface RecentProject {
  id: string;
  name: string;
}

interface Props {
  recentProjects: RecentProject[];
  onOpenProject: () => void;
  onStartChat: () => void;
  onOpenTerminal: () => void;
  onRecentClick?: (projectId: string) => void;
}

export function WelcomeView({
  recentProjects,
  onOpenProject,
  onStartChat,
  onOpenTerminal,
  onRecentClick,
}: Props) {
  return (
    <div className="welcome-view">
      <div className="welcome-view__card">
        <div className="welcome-view__logo">
          <Logo />
        </div>
        <h1 className="welcome-view__title">Welcome to Steerly</h1>
        <div className="welcome-view__divider">Get started</div>
        <button type="button" className="welcome-view__cta" onClick={onOpenProject}>
          <Folder size={16} /> <span>Open a project</span>
        </button>
        <button type="button" className="welcome-view__cta" onClick={onStartChat}>
          <MessageCircle size={16} /> <span>Start a new chat</span>
        </button>
        <button type="button" className="welcome-view__cta" onClick={onOpenTerminal}>
          <TerminalIcon size={16} /> <span>Open terminal</span>
        </button>
        {recentProjects.length > 0 && (
          <div className="welcome-view__recents">
            <div className="welcome-view__recents-label">Recent projects</div>
            {recentProjects.slice(0, 5).map((p) => (
              <button
                key={p.id}
                type="button"
                className="welcome-view__recent"
                onClick={() => onRecentClick?.(p.id)}
              >
                <span aria-hidden="true">·&nbsp;</span>
                <span>{p.name}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
